import { request } from '../../../gateways/api'

export { openKlantBijlage }

const openKlantBijlage = async ({
  id,
  bijlageId,
}: {
  id: string
  bijlageId: string
}) => {
  const result = await request({
    url: `/rest/project/${id}/klantbijlage/${bijlageId}`,
    method: 'GET',
  })

  const { url } = result.downloadData

  window.open(url, '_blank')
}
